if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();

        this.checkboxInput = this.querySelector(`#Recipient-checkbox-${this.dataset.sectionId}`);
        this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
        this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
        this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
        this.sendonInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`);
        this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${this.dataset.sectionId}`);

        this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');
        this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
        this.errorMessage = this.errorMessageWrapper?.querySelector('.error-message');
        this.defaultErrorHeader = this.errorMessage?.innerText || 'Please adjust the following:';

        this.form = this.closest('form');
        this.addToCartButton = this.form?.querySelector('[data-add-to-cart]');

        this.checkboxInput.disabled = false;

        if (this.offsetProperty) {
          this.offsetProperty.value = new Date().getTimezoneOffset().toString();
        }

        this.addEventListener('change', () => this.toggleFields());

        // 🔴 CRITICAL: intercept Impulse click
        this.addToCartButton?.addEventListener('click', (e) => {
          if (this.shouldBlockCart()) {
            e.preventDefault();
            e.stopImmediatePropagation(); // ⛔ blocks Impulse JS
            this.showErrors(this.getErrors());
          }
        });

        this.toggleFields();
      }

      toggleFields() {
        const enabled = this.checkboxInput.checked;

        [this.emailInput, this.nameInput, this.messageInput, this.sendonInput, this.offsetProperty]
          .filter(Boolean)
          .forEach((el) => (el.disabled = !enabled));

        if (!enabled) {
          this.clearErrors();
        }
      }

      shouldBlockCart() {
        return this.checkboxInput.checked && Object.keys(this.getErrors()).length > 0;
      }

      getErrors() {
        const errors = {};

        if (!this.emailInput.value.trim()) {
          errors.email = ["Email can't be blank"];
        }

        return errors;
      }

      getErrorIcon() {
  return `
    <svg xmlns="http://www.w3.org/2000/svg"
      height="18"
      width="18"
      viewBox="0 -960 960 960"
      fill="#EA3323"
      aria-hidden="true"
      focusable="false"
      style="margin-right:6px; flex-shrink:0;">
      <path d="M480-301.54q10.46 0 17.54-7.08 7.08-7.07 7.08-17.53 0-10.47-7.08-17.54-7.08-7.08-17.54-7.08-10.46 0-17.54 7.08-7.08 7.07-7.08 17.54 0 10.46 7.08 17.53 7.08 7.08 17.54 7.08Zm-20-132.31h40v-240h-40v240ZM480.13-120q-74.67 0-140.41-28.34-65.73-28.34-114.36-76.92-48.63-48.58-76.99-114.26Q120-405.19 120-479.87q0-74.67 28.34-140.41 28.34-65.73 76.92-114.36 48.58-48.63 114.26-76.99Q405.19-840 479.87-840q74.67 0 140.41 28.34 65.73 28.34 114.36 76.92 48.63 48.58 76.99 114.26Q840-554.81 840-480.13q0 74.67-28.34 140.41-28.34 65.73-76.92 114.36-48.58 48.63-114.26 76.99Q554.81-120 480.13-120Z"/>
    </svg>
  `;
}


      showErrors(errors) {
        this.clearErrors();

        // ❌ Do NOT show top error box
        this.errorMessageWrapper.hidden = true;

        Object.entries(errors).forEach(([key, messages]) => {
          const errorId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
          const field = this[`${key}Input`];
          const errorBlock = this.querySelector(`#${errorId}`);
          const errorText = errorBlock?.querySelector('.error-message');

          if (errorBlock && errorText) {
            errorText.innerHTML = `
            <span style="display:inline-flex; align-items:center;">
              ${this.getErrorIcon()}
              <span>${messages[0]}.</span>
            </span>
          `;

            errorBlock.classList.remove('hidden');
          }

          if (field) {
            field.setAttribute('aria-invalid', 'true');
            field.setAttribute('aria-describedby', errorId);
          }
        });
      }


      clearErrors() {
        this.errorMessageWrapper.hidden = true;
        if (this.errorMessageList) this.errorMessageList.innerHTML = '';

        this.querySelectorAll('.form__message').forEach((el) => {
          el.classList.add('hidden');
          const msg = el.querySelector('.error-message');
          if (msg) msg.innerText = '';
        });

        [this.emailInput, this.nameInput, this.messageInput, this.sendonInput].forEach((field) => {
          if (!field) return;
          field.removeAttribute('aria-invalid');
          field.removeAttribute('aria-describedby');
        });
      }
    }
  );
}
